// extracted by mini-css-extract-plugin
module.exports = {"home-container":"insurance_home-container__38Yzd"};